import { useTranslation } from 'react-i18next';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useIsMobile } from '@/hooks/use-mobile';

interface PropertyChartProps {
  data: Record<string, number>;
}

const formatNumber = (value: number) => value.toLocaleString('sv-SE');

export function PropertyChart({ data }: PropertyChartProps) {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const chartData = [
    { type: t('postal.properties.houses'), antal: data.properties_houses ?? 0 },
    { type: t('postal.properties.apartmentOwned'), antal: data.properties_apartment_owned ?? 0 },
    { type: t('postal.properties.apartmentRented'), antal: data.properties_apartment_rented ?? 0 },
    { type: t('postal.properties.other'), antal: data.properties_other ?? 0 },
  ];

  const tickSize = isMobile ? 9 : 11;

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm md:text-base">{t('postal.charts.propertyTypes')}</CardTitle>
      </CardHeader>
      <CardContent className="px-2 md:px-6">
        <ResponsiveContainer width="100%" height={isMobile ? 220 : 300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis dataKey="type" tick={{ fontSize: tickSize }} />
            <YAxis tick={{ fontSize: tickSize }} tickFormatter={formatNumber} width={isMobile ? 35 : 60} />
            <Tooltip
              contentStyle={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))' }}
              labelStyle={{ color: 'hsl(var(--foreground))' }}
              formatter={(value: number) => [formatNumber(value), t('postal.charts.numberOfProperties')]}
            />
            <Bar dataKey="antal" fill="hsl(45, 100%, 50%)" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
